<template>
  <div class="HideScrollbar" id="index">
    <div v-if="visible">
      <Header l="logo" r="服務" @lc="showEnter()" @rc="cmdMore()" @serviceClick="cmdService()" />
      <!-- {{ sGetConfig("chkUserInputCustCount") }} -->
      <!-- {{ sGetConfig("chkDisableAnimate") }} -->
      <!-- {{ sStopSale }} -->
      <!-- {{ sConfig }}
      {{ sGetConfig("bell") }}
      {{ sGetConfig("chkIndexTopBell") }} -->
      <!-- {{ enableBell() }} -->
      <!-- <van-button @click="$refs.rFrmInputCustCount.show()">click</van-button> -->
      <!-- {{ sCustCount }} -->
      <FrmInputCustCount ref="rFrmInputCustCount" v-if="sGetConfig('chkUserInputCustCount')" />
      <BellButton />

      <van-image :src="sGetConfig('storeImg')" width="100%" />

      <div style="margin: 1rem; line-height: 1.6rem">
        <div v-html="gNl2br(sGetConfig('storeNote'))"></div>
      </div>
      <div style="height: 0.5rem; background-color: #eee"></div>
      <!-- <van-button @click="showTimeTip()">AAAAAAAAAA</van-button> -->
      <MenuTB :bkmenu="sBKMenu" @click="showItem" />

      <!-- <MenuLR :bkmenu="bkmenu" :ordertmp="ordertmp" @click="showItem" /> -->

      <Footer :b1="btnCarText()" :anime="anime" @b1c="cmdCar()" />
    </div>

    <!-- 彈出層視窗 -->
    <!-- <FrmTimeTip ref="rFrmTimeTip" /> -->

    <!-- 彈出層視窗 -->
    <FrmItemDetail ref="rFrmItemDetail" @callback="refresh" />

    <!-- 歡迎頁 -->
    <Welcome ref="rWelcome" @close="showEnter" />

    <!-- 帳單頁 -->
    <OCheck ref="rOCheck" />

    <!-- 訂單頁 -->
    <PoH ref="rPoH" @close="showEnter" />

    <!-- 功能表 -->
    <More ref="rMore" />

    <!-- 購物車 -->
    <Car ref="rCar" @close="init()" />

    <!-- 進入頁 -->
    <Enter ref="rEnter" />
  </div>
</template>
<style scoped>
/* i {
  color: green;
} */
</style>
<script>
import qs from "qs";
import Header from "./Header.vue";
import Footer from "./Footer.vue";
import BellButton from "./BellButton.vue";
var fits = require("../../mixin/lib-fits-front");
export default {
  components: {
    Header,
    Footer,
    BellButton,
  },
  data() {
    return {
      ordertmp: [],
      rst: [], // ordertmp 格式化成array
      // bkmenu: null,
      anime: false,
      visible: false,
    };
  },
  async mounted() {
    console.log("Index.monted");
    await this.gInit();
    await this.initForm();
    // this.ordertmp = this.sOrdertmp;
    // this.$refs.rWelcome.show();
    // this.visible = true;
  },
  methods: {
    checkInputCustCount() {
      let tblid = fits.str(this.$route.query.tblid);
      if (tblid != "")
        if (this.sGetConfig("chkUserInputCustCount"))
          if (this.$store.state.sCustCount == 0) return false;

      return true;
    },
    async cmdCar() {
      this.gShowLoading();
      var res = await this.apiGetOrdertmp();
      this.$refs.rCar.show(res.data.objs, res.data.rst);
      this.gClearLoading();
    },
    cmdWelcome() {
      this.$refs.rWelcome.show();
    },
    cmdMore() {
      this.$refs.rMore.show();
    },
    cmdService() {
      this.$refs.rMore.show();
    },
    cmdOCheck() {
      this.$refs.rOCheck.showAndLoad();
    },
    showItem(obj) {
      if (!this.checkInputCustCount()) return this.$refs.rFrmInputCustCount.show();
      this.$refs.rFrmItemDetail.show(obj);
    },
    showTimeTip() {
      this.$refs.rFrmTimeTip.show();
    },
    async initForm() {
      try {
        this.visible = true;
        
        let chkForbidNoPassCode = this.sGetConfig("chkForbidNoPassCode"); // 檢查是否有PassCode
        if (chkForbidNoPassCode) {
          let tblid = this.$route.query.tblid;
          let passcode = this.$route.query.PassCode;
          if (tblid && !passcode) {
            this.gMsgbox("驗證碼不存在請重新掃碼").then(() => {
              return (window.location.href = "/?" + qs.stringify(this.$route.query));
            });
          }
        }

        document.title = this.sGetConfig("storeName");

        if (this.sGetConfig("kioskMode")) return this.$refs.rWelcome.show();

        if (this.sOrderI) {
          var sum = this.gSum(this.sOrderI, "Amt");
          if (sum > 0) {
            return this.$refs.rOCheck.show(this.sOrderH, this.sOrderI);
          } else if (sum == 0) {
            if (this.sOrderI.length > 0) {
              if (!this.sGetConfig("chkHideCheckWhenAmt0")) {
                return this.$refs.rOCheck.show(this.sOrderH, this.sOrderI); //有勾0先也要顯示帳單
              }
            }
          }
        }


        if (this.sPoH.length) {
          if (!this.sGetConfig("chkIndexNoPoList")) {
            return this.$refs.rPoH.show();
          }
        }

        //沒有交易，顯示歡迎頁
        // this.$refs.rEnter.show();

        //沒有交易，顯示歡迎頁
        this.$refs.rWelcome.show();

        // //取得菜單
        // var res = await this.apiGetMenus();
        // this.bkmenu = res.data;
        // this.$store.commit("setBKMenu", res.data); //太常用了，存在store
        // var menutype = res.data.menutype;
        // if (menutype.length > 0) {
        //   this.gSetCrtType(menutype[0]);
        // }

        //取得ordertmp
        // var res = await this.apiGetOrdertmp();
        // this.ordertmp = res.data.objs;
        // this.rst = res.data.rst;

        //取得帳單 -> 先不做，做的太聰明，user無法理解
        // res = await this.getOCheck();
        // var checkAmt = this.gSum(res.data.orderi, "Amt");
        // if (checkAmt > 0) {
        //   return this.$refs.rOCheck.show(res.data.orderh, res.data.orderi);
        // }

        // this.cmdWelcome();
        // this.gClearLoading();
      } catch (error) {
        console.log("initForm()", error);
        // this.gClearLoading();
      }
    },
    showEnter() {
      if (this.sGetConfig("noPhoneIuput")) {
        return;
      }

      //點單模式
      if (this.sPassCode != "" && this.sTblid != "") {
        return;
      }

      this.$refs.rEnter.show();
    },
    async getOCheck() {
      try {
        var tblid = this.$route.query.tblid;
        var passcode = this.$route.query.PassCode;
        var query = { tblid: tblid, passcode: passcode };
        return await this.apiGetOCheck(query);
      } catch (error) {
        console.log("getOCheck()", error);
      }
    },
    async refresh() {
      this.gShowLoading();
      var res = await this.apiGetOrdertmp();
      this.$store.commit("setOrderTmp", res.data);
      this.gClearLoading();
    },

    async callService(type) {
      var tblid = this.$route.query.tblid;
      var body = { tblid: tblid, type: type };
      var res = await this.apiCallService(body);
      console.log(res.data);
    },
    sum() {
      var output = {};
      output.Qty = this.gSum(this.sOrdertmp, "Qty");
      output.Amt = this.gSum(this.sRst, "Amt");
      return output;
    },
    btnCarText() {
      var sum = this.sum();
      if (sum.Qty == 0) {
        this.anime = false;
        return "點餐明細 Order Detail";
      } else {
        this.anime = true;
        if (this.sGetConfig("chkCartNoSumAmt"))
          return "餐點共" + sum.Qty + "份 Order Detail";

        return "餐點共" + sum.Qty + "份  $" + sum.Amt + "元 Order Detail";
      }
    },
  },
};
</script>
